module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/index.js
// module id = 118
// module chunks = 0